/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Institutionemail1Inputs */

const en__field_institutionemail1 = /** @type {(inputs: _Field_Institutionemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const de__field_institutionemail1 = /** @type {(inputs: _Field_Institutionemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/**
* | output |
* | --- |
* | "E-Mail" |
*
* @param {_Field_Institutionemail1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_institutionemail1 = /** @type {((inputs?: _Field_Institutionemail1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Institutionemail1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_institutionemail1(inputs)
	return de__field_institutionemail1(inputs)
});
export { _field_institutionemail1 as "_field_institutionEmail" }